export default __webpack_public_path__ + "static/media/shoe04.309deae5.jpg";